import React, { useEffect, useMemo, useRef, useState } from 'react'
import { connect, useIntl } from 'umi'
import { Layout, Card, Button, DatePicker, InputAdornment, Input, message, StatusTip, Table, Status } from 'tea-component';
import moment from 'moment';
import './speed.scss';
import { getHokPVPSpeed } from './service';
import { columns, DATE_FORMAT_STRING, testData } from './_config/config';
// import * as echarts from 'echarts';
import { buriedPoint } from '@/pages/home/utils/buriedPoint'
import Chart from '@/pages/home/components/Chart';

const {Content} = Layout;
const { RangePicker } = DatePicker;
const { pageable, scrollable, injectable } = Table.addons;
let requestId = 0;

const ToolTip = (v) => {
  const { value,  axisValue} = v[0] || {};
  return `<div class="hok-echart-tooltip"><span class="hok-tooltip-time">${moment(axisValue).format('HH:mm:ss')}</span><span/>${value || '-'}<span></div>`;
}

const setOtherConfigFunc = (option) => {
  option.xAxis[0].axisLabel.formatter = (value) => {
    return moment(value).format('HH:mm:ss');
  }
  // option.yAxis.name = '延迟/ms';
  // option.yAxis.nameLocation = 'start';
  return option;
}

const Speed = (props: any) => {
  const { gameCode } = props;
  const {formatMessage } = useIntl();
  const dateRef = useRef([moment().startOf('day'), moment()]);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataList, setDataList] = useState<any[]>([]);
  const [openid, setOpenid] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<moment.Moment[]>(dateRef.current);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const echartRef = useRef<any>(null);

  const getData = ({startDate, endDate, openid}) => {
    if (!openid) {
      message.warning({
        content: 'Please input the openid~'
      });
      return;
    }
    !loading && setLoading(true);
    let reqId = ++requestId;
    getHokPVPSpeed({
      open_id: openid,
      game_code: gameCode,
      start_time: startDate.format(DATE_FORMAT_STRING),
      end_time: endDate.format(DATE_FORMAT_STRING),
      order_by: ["start_time desc", "pvpid"]
    }).then((data) => {
      if (reqId !== requestId) {
        return;
      }
      // 测试数据
      data = [];
      const num = Math.round(Math.random() * 200);
      for (let i = 0; i < num; i++) {
        data.push(testData());
      }
      if (!Array.isArray(data)) {
        data = [];
      }
      setDataList(data || []);
      if (data.length > 0) {
        setSelectedRow(data[0]);
        setErrorMsg('')
      } else {
        setErrorMsg('未查询到相关记录~');
        setSelectedRow(null);
      }
    }, (error) => {
      if (reqId !== requestId) {
        return;
      }
      console.log('error', error);
      const errorMsg = error?.data?.msg || '请求失败，请稍后再试~'
      // message.error({
      //   content: errorMsg
      // });
      setErrorMsg(errorMsg);
      setDataList([]);
      setSelectedRow(null);
    }).catch(e=>{
      console.log(e)
    }).finally(() => {
      if (reqId !== requestId) {
        return;
      }
      setLoading(false);
    });
  }

  const handleClickConfirm = () => {
    const [startDate, endDate] = selectedDate;
    getData({ startDate, endDate, openid });
  }

  const handleClickReset = () => {
    setSelectedDate(dateRef.current);
    setOpenid('');
    setDataList([]);
    // const startDate = dateRef.current[0];
    // const endDate = dateRef.current[1];
    // getData({ startDate, endDate, openid: '' });
  }

  const chartOption = useMemo(() => {
    if (!selectedRow) {
      return null;
    }
    const { normalvalue, start_time, end_time } = selectedRow;
    if (!start_time || !end_time) {
      return null;
    }
    const data = normalvalue ? normalvalue.split(',') : [];
    const getXAxisData = () => {
      const start = moment(start_time).valueOf();
      const end = moment(end_time).valueOf();
      const micSec = end - start;
      const len = data.length;
      const minSec = 1 * 1000;
      // 最小间隔1s
      const interval = Math.max(Math.floor(micSec / len), minSec);
      const dateArr: any[] = [];
      let temDate = start;
      do {
        dateArr.push(moment(temDate).format(DATE_FORMAT_STRING));
        temDate += interval;
      } while (temDate < end);
      // 如果end 比上个数据大1s，就加入进去
      if (end >= temDate + minSec) {
        dateArr.push(moment(end).format(DATE_FORMAT_STRING));
      }
      return dateArr;
    };

    return {
      yAxis: {
        type: 'value'
      },
      xAxis: {
        type: 'category',
        data: getXAxisData(),
        axisLabel: {
          formatter: (value) => {
            return moment(value).format('HH:mm:ss');
          }
        }
      },
      series: {
        type: 'line',
        name: 'speed',
        data
      },
      grid: {
        left: 50,
        bottom: 20,
        right: 20,
        top: 20
      },
      tooltip: {
        show: true,
        // alwaysShowContent: true,
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        borderWidth: 0,
        borderRadius: 6,
        textStyle: {
          color: '#FFFFFF',
          fontSize: 10,
        },
        axisPointer: {
          type: 'line'
        },
        confine: true,
        hideDelay: 200,
        triggerOn: 'mousemove',
        padding: 0,
        formatter: ToolTip
      },
    };
  }, [selectedRow]);

  useEffect(()=>{
    if(gameCode) {
      buriedPoint({
        uid: gameCode,
        pageId: '202701',
        pageName: 'pvpSpeed',
        pagePath: '/pvp/speed',
      });
    }

  },[gameCode]);

  return (
    <Content className="oit-layout--fixtabs dtb-db-pvpspeed-container">
      <Content.Header
        title="PVP Speed"
      >
      </Content.Header>
      <Content.Body full>
        <Card>
          <Card.Body>
            <div className="dtb-filter-item-wrap">
              <>
                <RangePicker
                  // @ts-ignore
                  value={selectedDate}
                  className="dtb-filter-item"
                  showTime
                  onChange={value => {
                    setSelectedDate(value);
                  }}
                />
              </>
              <InputAdornment before="Openid" className="dtb-filter-item">
                <Input size="l"
                   value={openid}
                   onChange={(value) => {
                     setOpenid(value);
                   }}
                   placeholder="Please input openid"/>
              </InputAdornment>
            </div>
            <div className="dtb-filter-btn-wrap">
              <Button
                type='primary'
                onClick={handleClickConfirm}
              >
                Confirm
              </Button>
              <Button
                onClick={handleClickReset}
                type='weak'
              >
                Reset
              </Button>
            </div>
          </Card.Body>
        </Card>
        {
          loading ? <div className="dtd-pvp-loading-wrap">
              <StatusTip
              status='loading'
              loadingText={formatMessage({ id: 'common_loading'})}
            />
          </div> : errorMsg ? <Status
            description={errorMsg}
            className="dtb-loading"
          /> : dataList.length > 0 && <Card bordered>
            <Card.Body>
              <>
                <Table
                  rowClassName={(record) => {
                    return record.pvpid === selectedRow?.pvpid ? 'dtb-row-selected dtb-row-pointer' : 'dtb-row-pointer';
                  }}
                  bordered='all'
                  records={dataList}
                  recordKey="pvpid"
                  columns={columns}
                  addons={[
                    pageable(),
                    scrollable({ maxHeight: 540, scrollToTopOnChange: true }),
                    injectable({
                      row: (props, context) => {
                        return {
                          onClick: () => {setSelectedRow(context.record)}
                        }
                      }
                    })
                  ]}
                />
              </>
              {/*{selectedRow && <div id='hok-echarts' className="hok-chart-wrap"></div>}*/}
              {chartOption && <Card bordered className="hok-chart-container">
                <Card.Body>
                  {/*<Chart setOtherConfigFunc={setOtherConfigFunc} formatterFunc={ToolTip} height={400} legendData={['speed']} isShowLegend={false} chartType='line' xAxisData={chartOption?.xAxis?.data || []} series={chartOption?.series || []} />*/}
                  <div className="hok-chart-wrap"><Chart option={chartOption} /></div>
                </Card.Body>
              </Card>}
            </Card.Body>
          </Card>
        }
      </Content.Body>
    </Content>
  );
}

export default connect((state: any) => {
  return {
    gameCode: state.dashboard?.gameCode?.gameCode
  };
})(Speed);
